import { render } from "./PaymentTypes.vue?vue&type=template&id=366c770e&scoped=true"
import script from "./PaymentTypes.vue?vue&type=script&lang=js"
export * from "./PaymentTypes.vue?vue&type=script&lang=js"

import "./PaymentTypes.vue?vue&type=style&index=0&id=366c770e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366c770e"]])

export default __exports__